<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div style="min-width: 200px">
        <v-tabs v-model="tab" grow class="tab-btn-style">
          <v-tab class="c-tab" v-if="permitObj.catchups">Catchups</v-tab>
          <v-tab class="c-tab" v-if="permitObj.requests">Request</v-tab>
          <v-tab class="c-tab" v-if="permitObj.absents">Absent</v-tab>
          <v-tab class="c-tab" v-if="permitObj.complete">Complete</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item v-if="permitObj.catchups">
          <catchup-table :id="tab"></catchup-table>
        </v-tab-item>
        <v-tab-item v-if="permitObj.requests">
          <request-table :id="tab"></request-table>
        </v-tab-item>
        <v-tab-item v-if="permitObj.absents">
          <approve-table :id="tab"></approve-table>
        </v-tab-item>
        <v-tab-item v-if="permitObj.complete">
          <complete-table :id="tab" ></complete-table>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import RequestTable from "../../../components/catchups/RequestTable";
import ApproveTable from "../../../components/catchups/ApproveTable";
import CompleteTable from "../../../components/catchups/CompleteTable";
import CatchupTable from "../../../components/catchups/CatchupTable";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "CatchUps",
  components: { CatchupTable,ApproveTable, RequestTable, CompleteTable, BreadCrumbs },
  data() {
    return {
      tab: null,
      permitObj:{},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name
          }
        }
      ]
    };
  },
  watch: {
    tab(){
      // alert(this.tab)
      if(this.tab == 0){
        // this.$emit('update-cart','cal')
        // console.log('update-cart')
        this.$store.state.catchups = "ssss";
      }
    }
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "CatchUps";
      this.permitObj = getPermitObjects(links, pathName)
    }
  },
  mounted() {
    this.getPermittedArray();
  }
};
</script>

<style lang="scss" scoped>
.nmt-1 {
  margin-top: -12px;
}
.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;
  &.v-tab--active {
    background: white;
  }
}
</style>